<template>

  <div class="widget-content-product" :class="{ 'image-only': isImageOnly }" :style="{ '--dmb-widget-content-product-image-size': resolvedImageSize }" v-if="product">
    <div class="product-image" v-if="settings.showImage && imageAsset" v-background-image="imageAsset.url"></div>
    <div class="title" v-if="settings.showTitle || settings.showSubtitle || (settings.showLabels !== false && badgeLabels(product).length)">
      <div class="title-inner">

        <dmb-widget-styled-text v-if="settings.showTitle" :style="settings.titleTextStyle">{{
            product.title
          }}
        </dmb-widget-styled-text>
        <dmb-label-badges v-if="settings.showLabels !== false && badgeLabels(product).length && settings.labelPosition !== 'BELOW'"
                          :labels="badgeLabels(product)" :text-style="settings.labelTextStyle || settings.subtitleTextStyle" :image-size="settings.labelImageSize"></dmb-label-badges>
      </div>
      <template v-if="settings.showSubtitle">
        <dmb-widget-styled-text v-for="(line, i) in subtitleLines(product)" :key="i" :style="settings.subtitleTextStyle">
          {{ line }}
        </dmb-widget-styled-text>
      </template>
      <dmb-label-badges v-if="settings.showLabels !== false && badgeLabels(product).length && settings.labelPosition === 'BELOW'"
                        :labels="badgeLabels(product)" :text-style="settings.labelTextStyle || settings.subtitleTextStyle" :image-size="settings.labelImageSize"></dmb-label-badges>
    </div>

    <div class="price" v-for="priceOption in prices" v-if="settings.showPrice || settings.showVariant">
      <dmb-widget-styled-text v-if="settings.showVariant" :style="settings.variantTextStyle">
        {{ priceOption.variant.title }}
      </dmb-widget-styled-text>
      <dmb-widget-styled-text class="price-value" v-if="settings.showPrice" :style="settings.priceTextStyle">
        <dmb-price :currency="settings.showCurrency" :mode="settings.priceMode" :price="priceOption.price"/>
      </dmb-widget-styled-text>
    </div>
  </div>
  <div v-else-if="freeze" class="widget-content-placeholder">{{
      $t('app.widgets.widgetContentProduct.noProduct')
    }}
  </div>

</template>

<script>

import {Vue, Options} from 'vue-class-component'
import {isNil, sortBy} from 'lodash';

import WidgetStyledText from '../WidgetStyledText.vue';
import Price from '../Price.vue';

import ProductState from '../../enum/ProductState';
import Asset from "../ui/Asset.vue";
import LabelBadges from './LabelBadges.vue';
import {subtitleLines} from '../../util/labelDisplay';

export default Options({
  name: 'dmb-widget-content-product',
  components: {
    [WidgetStyledText.name]: WidgetStyledText,
    [Asset.name]: Asset,
    [Price.name]: Price,
    [LabelBadges.name]: LabelBadges,
  },
  props: {
    widget: Object,
    freeze: Boolean
  }
})(
    class WidgetContentProduct extends Vue {

      get settings() {

        return this.widget.settings;
      }

      get product() {

        const product = this.$store.getters.getProduct(this.widget.settings.productId);
        if (!product) {
          return null;
        }

        if (!this.freeze && product.state !== ProductState.AVAILABLE) {
          return null;
        }

        return product;
      }

      get resolvedImageSize() {

        const size = !isNil(this.settings.imageSize) ? this.settings.imageSize : 50;
        return size + 'px';
      }

      get imageAsset() {

        return this.product.imageAssetId ? this.$store.getters.getAsset(this.product.imageAssetId) : null;
      }

      subtitleLines(product) {

        return subtitleLines(product);
      }

      badgeLabels(product) {

        return product.labels || [];
      }


      get prices() {

        if (!this.product) {
          return [];
        }

        if (this.settings.variantId) {
          return this.product.prices.filter(price => price.variantId.toString() === this.settings.variantId.toString());
        } else {
          return sortBy(this.product.prices, 'variant.sortIndex');
        }
      }

      get showStyle() {

        return this.$store.state.style.showStyle;
      }

      get isImageOnly() {

        const st = this.settings;
        return st.showImage && !st.showTitle && !st.showSubtitle && !st.showPrice && !st.showVariant;
      }
    }
)

</script>
<style src="../../../scss/component/widget/WidgetContentProduct.scss" lang="scss"></style>
